/**
 * Created by vladislav on 7/8/2025
 */

const PUSHES = {
    BONUS_ROUND: {
        id: 2,
        title: "LocalPushes.BONUS_ROUND.Title",
        message: "LocalPushes.BONUS_ROUND"
    },

    LIVES: {
        id: 3,
        title: "LocalPushes.LIVES.Title",
        message: "LocalPushes.LIVES",
        pushImg: "lives.jpg"
    },

    MINI_GAME: {
        id: 4,
        title: "LocalPushes.MINI_GAME.Title",
        message: "LocalPushes.MINI_GAME"
    },

    LETS_PLAY_1: {
        id: 5,
        title: "LocalPushes.LETS_PLAY.Title",
        message: "LocalPushes.LETS_PLAY"
    },

    FREE_CHEST: {
        id: 6,
        title: "LocalPushes.FREE_CHEST.Title",
        message: "LocalPushes.FREE_CHEST"
    },

    ENERGY_LOTTERY: {
        id: 7,
        title: "LocalPushes.LIVES_LOTTERY.Title",
        message: "LocalPushes.LIVES_LOTTERY"
    },

    FRUIT_RIPE: {
        id: 8,
        title: "LocalPushes.FRUIT_RIPE.Title",
        message: "LocalPushes.FRUIT_RIPE"
    },

    CASTLE_PRIZE: {
        id: 9,
        title: "LocalPushes.CASTLE_PRIZE.Title",
        message: "LocalPushes.CASTLE_PRIZE"
    },

    ORDER_READY: {
        id: 10,
        title: "LocalPushes.ORDER_READY.Title",
        message: "LocalPushes.ORDER_READY",
        pushImg: "order_ready.jpg"
    },

    TREE_CHOPPED: {
        id: 11,
        title: "LocalPushes.TREE_CHOPPED.Title",
        message: "LocalPushes.TREE_CHOPPED",
        pushImg: "tree_chopped.jpg"
    },

    BUILDING_BUILT: {
        id: 12,
        title: "LocalPushes.BUILDING_BUILT.Title",
        message: "LocalPushes.BUILDING_BUILT",
        pushImg: "building_built.jpg"
    },

    MAGIC_PLANT_READY: {
        id: 13,
        title: "LocalPushes.MAGIC_PLANT_READY.Title",
        message: "LocalPushes.MAGIC_PLANT_READY"
    },

    MINI_GAME_PRIZE: {
        id: 14,
        title: "LocalPushes.MINI_GAME_PRIZE.Title",
        message: "LocalPushes.MINI_GAME_PRIZE"
    },

    DAILY_TASKS_UNCOMPLETED: {
        id: 15,
        title: "LocalPushes.DAILY_TASKS_UNCOMPLETED.Title",
        message: "LocalPushes.DAILY_TASKS_UNCOMPLETED"
    },

    PASS_UNCOMPLETED: {
        id: 16,
        title: "LocalPushes.PASS_UNCOMPLETED.Title",
        message: "LocalPushes.PASS_UNCOMPLETED"
    },

    PUMPKIN_RIPE: {
        id: 17,
        title: "LocalPushes.PUMPKIN_RIPE.Title",
        message: "LocalPushes.PUMPKIN_RIPE"
    },

    UNITLOCK_OPEN: {
        id: 18,
        msstartId: 0,
        title: "LocalPushes.UNITLOCK_OPEN.Title",
        message: "LocalPushes.UNITLOCK_OPEN",
        pushImg: "unitlock_open.jpg"
    },

    EXPEDITION: {
        id: 19,
        title: "LocalPushes.EXPEDITION.Title",
        message: "LocalPushes.EXPEDITION",
        pushImg: "expedition.jpg"
    },

    EXPEDITION_TREE_CHOPPED: {
        id: 20,
        title: "LocalPushes.EXPEDITION_TREE_CHOPPED.Title",
        message: "LocalPushes.EXPEDITION_TREE_CHOPPED",
        pushImg: "tree_chopped.jpg"
    },

    LETS_PLAY_2: {
        id: 22,
        title: "LocalPushes.LETS_PLAY.Title",
        message: "LocalPushes.LETS_PLAY"
    },
    LETS_PLAY_3: {
        id: 23,
        title: "LocalPushes.LETS_PLAY.Title",
        message: "LocalPushes.LETS_PLAY"
    },
    LETS_PLAY_4: {
        id: 24,
        title: "LocalPushes.LETS_PLAY.Title",
        message: "LocalPushes.LETS_PLAY"
    },
    LETS_PLAY_5: {
        id: 25,
        title: "LocalPushes.LETS_PLAY.Title",
        message: "LocalPushes.LETS_PLAY"
    },

    WELCOME: {
        id: 26,
        msstartId: 1,
        title: "LocalPushes.WELCOME.Title",
        message: "LocalPushes.WELCOME"
    },

    ENERGY_EXPEDITION: {
        id: 27,
        title: "LocalPushes.ENERGY_EXPEDITION.Title",
        message: "LocalPushes.ENERGY_EXPEDITION",
        pushImg: "expedition.jpg"
    },

    EXPEDITION_NEW: {
        id: 28,
        title: "LocalPushes.EXPEDITION_NEW.Title",
        message: "LocalPushes.EXPEDITION_NEW",
        pushImg: "expedition.jpg"
    },

    EXPEDITION_END: {
        id: 29,
        title: "LocalPushes.EXPEDITION_END.Title",
        message: "LocalPushes.EXPEDITION_END",
        pushImg: "expedition.jpg"
    },

    PIGGY_BANK_FULL: {
        id: 30,
        title: "LocalPushes.PIGGY_BANK_FULL.Title",
        message: "LocalPushes.PIGGY_BANK_FULL"
    },

    MASS: {
        id: 1000
    }
};

for (const key in PUSHES) {
    PUSHES[key].code = key.toLowerCase();
}

if (typeof cc === "undefined") {
    module.exports = PUSHES;
}